<template>
    <section class="p-filters">
        <template v-if="renderComponent">
            <div class="p-filters__wrap">
                <a
                    class="p-filters__link"
                    href="/property/favorites/"
                    title="Перейти в избранное">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.64066 1.66214C10.1665 1.44424 10.7302 1.33209 11.2994 1.33209C11.8687 1.33209 12.4323 1.44424 12.9582 1.66214C13.484 1.88 13.9617 2.1993 14.3641 2.60179C14.7666 3.00416 15.0861 3.4821 15.3039 4.00788C15.5218 4.53375 15.634 5.09741 15.634 5.66664C15.634 6.23588 15.5218 6.79953 15.3039 7.32541C15.0861 7.85124 14.7667 8.32899 14.3642 8.73138L8.47083 14.6247C8.21048 14.8851 7.78837 14.8851 7.52802 14.6247L1.63469 8.73138C0.821871 7.91856 0.365234 6.81614 0.365234 5.66664C0.365234 4.51714 0.821871 3.41472 1.63469 2.6019C2.44751 1.78909 3.54993 1.33245 4.69943 1.33245C5.84893 1.33245 6.95135 1.78909 7.76417 2.6019L7.99943 2.83717L8.23458 2.60202C8.63697 2.19947 9.11483 1.88002 9.64066 1.66214ZM11.2994 2.66543C10.9053 2.66543 10.5151 2.74307 10.1511 2.89392C9.78698 3.04477 9.4562 3.26588 9.17761 3.5446L8.47083 4.25138C8.21048 4.51173 7.78837 4.51173 7.52802 4.25138L6.82136 3.54471C6.25859 2.98194 5.49531 2.66578 4.69943 2.66578C3.90355 2.66578 3.14027 2.98194 2.5775 3.54471C2.01473 4.10748 1.69857 4.87076 1.69857 5.66664C1.69857 6.46252 2.01473 7.2258 2.5775 7.78857L7.99943 13.2105L13.4214 7.78857C13.7001 7.50998 13.9213 7.17909 14.0721 6.81502C14.223 6.45095 14.3006 6.06073 14.3006 5.66664C14.3006 5.27256 14.223 4.88234 14.0721 4.51827C13.9213 4.1542 13.7002 3.82342 13.4215 3.54482C13.1429 3.2661 12.8119 3.04477 12.4478 2.89392C12.0837 2.74307 11.6935 2.66543 11.2994 2.66543Z"
                            fill="#252628"/>
                    </svg>
                    <span>Перейти в избранное</span>
                </a>
                <radio
                    :radio-data="filterData.sale_type"
                    :radio-name="'sale_type'"
                    :onload-value="URLParamsValues.sale_type"
                    @radio-selected="fieldsHandler" />
            </div>
            <div
                class="p-filters__wrapper"
                ref="filtersWrap">
                <div class="p-filters__content">
                    <div
                        class="p-filters__form"
                        id="filterForm">
                        <div class="p-filters__field-wrap" ref="search">
                            <search
                                :placeholder="'Поиск по адресу недвижимости'"
                                :onload-value="URLParamsValues.search"
                                @search-done="fieldsHandler" />
                        </div>
                        <div class="p-filters__field-wrap" ref="region">
                            <select-with-search
                                :filter-data="filterData.regions"
                                :placeholder="'Выберите субъект'"
                                :label="'Субъект РФ'"
                                :field-name="'regions[]'"
                                :onload-value="URLParamsValues.regions"
                                @choosen-filter-items="fieldsHandler" />
                        </div>
                        <div class="p-filters__field-wrap">
                            <simple-select
                                :select-data="filterData.object_type"
                                :placeholder="'Выберите тип'"
                                :label="'Тип жилья'"
                                :field-name="'object_type'"
                                :onload-value="URLParamsValues.object_type"
                                @select-choosen="fieldsHandler" />
                        </div>
                        <div
                            v-if="filtersVisible"
                            class="p-filters__field-wrap">
                            <multi-select
                                :select-data="filterData.rooms"
                                :placeholder="'Выберите количество комнат'"
                                :label="'Количество комнат'"
                                :field-name="'rooms[]'"
                                :onload-value="URLParamsValues.rooms"
                                @choosen-filter-items="fieldsHandler" />
                        </div>
                        <div
                            v-if="filtersVisible"
                            class="p-filters__field-wrap">
                            <simple-select
                                :select-data="filterData.condition"
                                :placeholder="'Выберите параметр'"
                                :label="'Наличие обременения'"
                                :tooltip="'Объекты, в которых зарегистрированы и/или проживают третьи лица. Такие объекты реализуются со скидкой.'"
                                :field-name="'condition'"
                                :onload-value="URLParamsValues.condition"
                                @select-choosen="fieldsHandler" />
                        </div>
                        <div
                            v-if="filtersVisible"
                            class="p-filters__field-wrap">
                            <range-slider
                                :slider-data="filterData.area"
                                :label="'Общая площадь, м²'"
                                :field-names="['area_min', 'area_max']"
                                :onload-value="[URLParamsValues.area_min, URLParamsValues.area_max]"
                                @range-slider-update="rangeHandler" />
                        </div>
                        <div
                            v-if="filtersVisible"
                            class="p-filters__field-wrap">
                            <range-slider
                                :disabled="fields.object_type === 'FLAT' || fields.object_type === 'ROOM' ? true : false"
                                :slider-data="filterData.sectionarea"
                                :label="'Площадь участка, м²'"
                                :field-names="['sectionarea_min', 'sectionarea_max']"
                                :onload-value="[URLParamsValues.sectionarea_min, URLParamsValues.sectionarea_max]"
                                @range-slider-update="rangeHandler" />
                        </div>
                        <div
                            v-if="filtersVisible"
                            class="p-filters__field-wrap">
                            <range-slider
                                :slider-data="filterData.price"
                                :label="'Стоимость, руб'"
                                :field-names="['price_min', 'price_max']"
                                :onload-value="[URLParamsValues.price_min, URLParamsValues.price_max]"
                                @range-slider-update="rangeHandler" />
                        </div>
                        <div
                            v-if="filtersVisible"
                            class="p-filters__field-wrap">
                            <simple-select
                                :disabled="fields.sale_type === 'without_auc' ? true : false"
                                :select-data="filterData.lot_status"
                                :placeholder="'Выберите тип'"
                                :label="'Тип аукциона'"
                                :field-name="'lot_status'"
                                :onload-value="URLParamsValues.lot_status"
                                @select-choosen="fieldsHandler" />
                        </div>

                        <teleport
                            v-if="isMounted"
                            to=".p-filters"
                            :disabled="!isTablet">
                            <div
                                v-if="filtersVisible || isTablet"
                                class="p-filters__btn-wrap">
                                <button
                                    class="p-filters__reset"
                                    @click.prevent="resetFilter">
                                    Очистить фильтр
                                </button>
                                <div class="p-filters__count">
                                    {{`Найдено ${getSubmitBtnText(offersCount)}`}}
                                </div>
                            </div>
                       </teleport>
                    </div>
                </div>
            </div>
            <Transition>
                <button
                    v-show="!filtersVisible"
                    class="p-filters__link show-filters"
                    @click.prevent="showFilters">
                    <span>{{showMoreText}}</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none">
                        <g clip-path="url(#clip0_1239_21494)">
                            <path d="M5.25 9.5C6.78619 9.5 8.07345 10.5658 8.41264 11.9983L17.75 12C18.1642 12 18.5 12.3358 18.5 12.75C18.5 13.1297 18.2178 13.4435 17.8518 13.4932L17.75 13.5L8.41288 13.5007C8.07405 14.9337 6.78655 16 5.25 16C3.71345 16 2.42594 14.9337 2.08712 13.5007L-0.75 13.5C-1.16421 13.5 -1.5 13.1642 -1.5 12.75C-1.5 12.3703 -1.21785 12.0565 -0.851771 12.0068L-0.75 12L2.08712 11.9993C2.42594 10.5663 3.71345 9.5 5.25 9.5ZM5.25 11C4.48586 11 3.83611 11.4898 3.59753 12.1725L3.57696 12.2352L3.53847 12.3834C3.51326 12.5016 3.5 12.6242 3.5 12.75C3.5 12.9048 3.52011 13.055 3.55785 13.1979L3.59766 13.3279L3.62335 13.3966C3.88055 14.0431 4.51191 14.5 5.25 14.5C6.01376 14.5 6.66324 14.0107 6.90212 13.3285L6.94218 13.1978L6.9251 13.2581C6.97381 13.0973 7 12.9267 7 12.75C7 12.6452 6.99078 12.5425 6.97312 12.4428L6.94309 12.3057L6.92308 12.2353L6.87625 12.1024C6.61881 11.4565 5.98771 11 5.25 11ZM11.75 0C13.2866 0 14.5741 1.06632 14.9129 2.49934L17.75 2.5C18.1642 2.5 18.5 2.83579 18.5 3.25C18.5 3.6297 18.2178 3.94349 17.8518 3.99315L17.75 4L14.9129 4.00066C14.5741 5.43368 13.2866 6.5 11.75 6.5C10.2134 6.5 8.92595 5.43368 8.58712 4.00066L-0.75 4C-1.16421 4 -1.5 3.66421 -1.5 3.25C-1.5 2.8703 -1.21785 2.55651 -0.851771 2.50685L-0.75 2.5L8.58736 2.49833C8.92655 1.06582 10.2138 0 11.75 0ZM11.75 1.5C10.9859 1.5 10.3361 1.98976 10.0975 2.6725L10.077 2.73515L10.0385 2.88337C10.0133 3.0016 10 3.12425 10 3.25C10 3.40483 10.0201 3.55497 10.0579 3.69794L10.0977 3.82787L10.1234 3.89664C10.3805 4.54307 11.0119 5 11.75 5C12.5138 5 13.1632 4.51073 13.4021 3.82852L13.4422 3.69781L13.4251 3.75808C13.4738 3.59729 13.5 3.4267 13.5 3.25C13.5 3.14518 13.4908 3.04251 13.4731 2.94275L13.4431 2.80565L13.4231 2.73529L13.3763 2.60236C13.1188 1.95647 12.4877 1.5 11.75 1.5Z" fill="#252628"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1239_21494">
                            <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </Transition>
        </template>
        <section class="p-filters__footer">
            <sort-toggler
                v-if="fields.VIEW_MODE !== 'view-map'"
                :onload-value="URLParamsValues.sort"
                @sort-changed="fieldsHandler" />
            <view-mode-tabs
                :is-mobile="isMobile"
                :is-tablet="isTablet"
                :onload-value="URLParamsValues.VIEW_MODE"
                @view-mode-selected="viewModeHandler" />
        </section>
    </section>
</template>

<script>
    import SimpleSelect from './SimpleSelect'
    import Radio from './Radio'
    import Search from './Search'
    import SelectWithSearch from './SelectWithSearch'
    import MultiSelect from './MultiSelect'
    import RangeSlider from './RangeSlider'
    import SortToggler from './SortToggler'
    import ViewModeTabs from './ViewModeTabs'

    import declineWordOfNum from '../../../modules/decline-word-of-num.js'
    import URLHelper from '../../../modules/URLHelper'

    export default {
        name: 'Filters',
        components: {
            Radio,
            SimpleSelect,
            Search,
            SelectWithSearch,
            MultiSelect,
            RangeSlider,
            SortToggler,
            ViewModeTabs,
        },
        props: {
            filterData: {
                type: Object,
                default: () => {}
            },
            offersCount: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                isMounted: false,
                filtersVisible: false,
                renderComponent: true,
                choosenRegion: null,
                showMoreText: 'Фильтр',
                fields: {},
                apiParams: null,
                historyParams: null,
                wait: false,
                URLParamsValues: {
                    sale_type: '',
                    search: '',
                    regions: '',
                    object_type: '',
                    rooms: '',
                    condition: '',
                    area_min: '',
                    area_max: '',
                    sectionarea_min: '',
                    sectionarea_max: '',
                    price_min: '',
                    price_max: '',
                    lot_status: '',
                    VIEW_MODE: '',
                    sort: '',
                    page: ''
                },
            }
        },
        computed: {
            isTablet () {
                return typeof window === 'object' && window.innerWidth >= 768 && window.innerWidth < 1200
            },
            isMobile () {
                return typeof window === 'object' && window.innerWidth < 768
            },
        },
        methods: {
            SeoChpuHandler (name, value) {
                const regions = this.filterData.regions.url
                let region = '';
                if (name === 'regions[]' && Object.values(value).length === 1) {
                    region = regions[Object.values(value)[0]]
                }
                if (name === 'regions[]' && Object.values(value).length !== 1) {
                    region = 'empty'
                }

                const types = this.filterData.object_type.values
                let objectType = '';
                if (name === 'object_type') {
                    objectType = value.toLowerCase()
                }
                if (name === 'object_type' && !value) {
                    objectType = 'empty'
                }

                const path = window.location.pathname
                let pathArr = path.split('/property/').filter(el => el !== '')
                let chpuPathArr = []

                if (pathArr.length > 0) {
                    chpuPathArr = pathArr.join('').split('/').filter(el => el !== '')
                }

                let newChpu = []
                if (region && region !== 'empty') {
                    newChpu.push(region)
                }

                if (objectType && objectType !== 'empty') {
                    newChpu.push(objectType)
                }

                if (chpuPathArr.length > 0) {
                    chpuPathArr.forEach(el => {
                        if (Object.values(regions).includes(el)) {
                            if (region === 'empty') {
                                newChpu.push('')
                                return
                            }

                            if (!region) {
                                newChpu.push(el)
                                return
                            }
                        }

                        if (Object.keys(types).map(el => el.toLowerCase()).includes(el)) {
                            if (!objectType) {
                                newChpu.push(el)
                                return
                            }
                            if (objectType === 'empty') {
                                newChpu.push('')
                                return
                            }
                        }
                    })
                }

                let newPath = 'property';
                if (newChpu.filter(el => el !== '').length > 0) {
                    newPath = `property/${newChpu.filter(el => el !== '').join('/')}`
                }
                history.pushState(null, null, `${window.location.origin}/${newPath}/${window.location.search}`);
            },

            getVisibleTabletFilterArea () {
                const MARGIN_BETWEEN_ROWS = 24
                return this.$refs.search.offsetHeight + this.$refs.region.offsetHeight + MARGIN_BETWEEN_ROWS * 2
            },

            forceRerender() {
                this.renderComponent = false;
                
                this.$nextTick(() => {
                    this.renderComponent = true;
                });
            },

            removeEmptyKeys(obj) {
                return Object.entries(obj)
                    .filter(([_, v]) => v != '')
                    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
            },

            createUrlParam(obj) {
                let apiParams = [];
                let historyParams = []
                Object.entries(obj).forEach(el => {
                    if (el[0] === 'regions[]' || el[0] === 'rooms[]') {
                        if (typeof el[1] !== 'string') {
                            Object.values(el[1]).forEach(itemEl => {
                                apiParams.push(`${el[0]}=${itemEl}`)
                            })
                        } else {
                            apiParams.push(`${el[0]}=${el[1]}`)
                        }

                        if (el[0] === 'rooms[]') {
                            historyParams.push(`${el[0].split('[]')[0]}=${el[1]}`)
                        }

                        if (el[0] === 'regions[]' && Object.values(el[1]).length > 1 && typeof el[1] !== 'string') {
                            historyParams.push(`${el[0].split('[]')[0]}=${el[1]}`)
                        }
                        return
                    }

                    if (el[0] === 'price_min,price_max'
                        || el[0] === 'area_min,area_max'
                        || el[0] === 'sectionarea_min,sectionarea_max') {
                            apiParams.push(`${el[0].split(',')[0]}=${Object.values(el[1])[0]}`)
                            apiParams.push(`${el[0].split(',')[1]}=${Object.values(el[1])[1]}`)
                            historyParams.push(`${el[0].split(',')[0]}=${Object.values(el[1])[0]}`)
                            historyParams.push(`${el[0].split(',')[1]}=${Object.values(el[1])[1]}`)
                            return
                    }

                    if (el[0] !== 'VIEW_MODE') {
                        apiParams.push(`${el[0]}=${el[1]}`)
                    }

                    if (el[0] !== 'object_type') {
                        historyParams.push(`${el[0]}=${el[1]}`)
                    }
                })

                return [apiParams, historyParams]
            },

            submitFilterData (delay = 0) {
                const DELAY = delay;
                if (!this.wait) {
                    this.wait = true;
                    setTimeout(() => {
                        this.wait = false;
                        this.$emit('submitFilterData')
                    }, DELAY);
                }
            },

            rangeHandler (name, value) {
                if (this.filterData[name[0].split('_')[0]].min === value[0]
                    && this.filterData[name[0].split('_')[0]].max === value[1]) {
                    this.fields[name[0]] = ''
                    this.fields[name[1]] = ''
                } else if (this.filterData[name[0].split('_')[0]].min === value[0]) {
                    this.fields[name[1]] = value[1]
                    this.fields[name[0]] = ''
                } else if (this.filterData[name[0].split('_')[0]].max === value[1]) {
                    this.fields[name[1]] = ''
                    this.fields[name[0]] = value[0]
                } else {
                    this.fields[name[0]] = value[0]
                    this.fields[name[1]] = value[1]
                }

                this.updateParams()
                this.submitFilterData(500)
            },

            fieldsHandler (name, value) {
                this.fields[name] = value
                this.updateParams()
                
                if (name === 'object_type' || 'regions[]') {
                    this.SeoChpuHandler(name, value)
                }

                if (this.isTablet) {
                    this.filtersHeightControll()
                }

                this.submitFilterData()
            },

            updateParams () {
                const updatedFields = this.removeEmptyKeys(this.fields)
                this.apiParams = this.createUrlParam(updatedFields)[0].join('&')
                this.historyParams = this.createUrlParam(updatedFields)[1].join('&')
                this.$emit('updateFilter', this.apiParams, this.historyParams)
            },

            filtersHeightControll (mount) {
                setTimeout(() => {
                    if (this.filtersVisible) {
                        setTimeout(() => {
                            this.$refs.filtersWrap.style.overflow = 'visible'
                        }, 500)
                    }

                    if (this.isTablet && mount) {
                        this.$refs.filtersWrap.style.maxHeight = `${this.getVisibleTabletFilterArea()}px`
                        return
                    }

                    if (this.isMobile && mount) {
                        this.$refs.filtersWrap.style.maxHeight = 0
                        return
                    }

                    this.$refs.filtersWrap.style.maxHeight = `${this.$refs.filtersWrap.scrollHeight}px`
                }, 0)
            },

            showFilters () {
                this.filtersVisible = true
                this.filtersHeightControll()
            },

            resetFilter () {
                this.forceRerender()
                this.fields = {
                    VIEW_MODE: this.fields.VIEW_MODE
                }

                this.historyParam = ''
                this.apiParams = ''
                
                Object.keys(this.URLParamsValues).forEach(el => this.URLParamsValues[el] = '')
                this.$emit('resetFilter')
                this.$emit('submitFilterData')
                this.filtersHeightControll()
            },

            formatWordOfNum (num, textArr) {
                return declineWordOfNum(num, textArr)
            },

            getSubmitBtnText(num) {
                return `${num} ${this.formatWordOfNum(num, ['объект', 'объекта', 'объектов'])}`
            },

            viewModeHandler (name, value) {
                this.fields[name] = value
                const updatedFields = this.removeEmptyKeys(this.fields)
                this.historyParams = this.createUrlParam(updatedFields)[1].join('&')
                this.$emit('updateFilter', this.apiParams, this.historyParams)
                this.$emit('updateViewMode', value)
            }
        },
        mounted() {
            this.isMobile || this.isTablet ? this.filtersVisible = false : this.filtersVisible = true
            if (this.isTablet) {
                this.showMoreText = 'Расширенный фильтр'
            }

            this.$nextTick(() => {
                this.isMounted = true;
                this.filtersHeightControll(true)
            })
        },
        created() {
            if (window.location.search) {
                Object.keys(this.URLParamsValues).forEach(el => {
                    if (URLHelper.getParamVal(el)) {
                        this.URLParamsValues[el] = URLHelper.getParamVal(el)
                    }
                })

                Object.entries(this.URLParamsValues).forEach(el => {
                    if (el[1]) {
                        if (el[0] === 'rooms' || el[0] === 'regions') {
                            this.fields[el[0] + '[]'] = el[1].split(',')
                        } else {
                            this.fields[el[0]] = el[1]
                        }
                    }
                })
            }

            const regions = this.filterData.regions.url
            const types = this.filterData.object_type.values
            const path = window.location.pathname
            let pathArr = path.split('/property/').filter(el => el !== '')
            let chpuPathArr = []

            if (pathArr.length > 0) {
                chpuPathArr = pathArr.join('').split('/').filter(el => el !== '')
            }

            if (chpuPathArr.length > 0) {
                chpuPathArr.forEach(element => {
                    if (Object.values(regions).includes(element)) {
                        this.URLParamsValues.regions = Object.entries(regions).filter(el => el[1] === element)[0][0]
                        this.fields['regions[]'] = Object.entries(regions).filter(el => el[1] === element)[0][0]
                    }

                    if (Object.keys(types).map(el => el.toLowerCase()).includes(element)) {
                        this.URLParamsValues.object_type = element.toUpperCase()
                        this.fields.object_type = element.toUpperCase()
                    }
                })
            }
            
            this.updateParams()
        }
    }
</script>